export enum DASHBOARD_TITLES {
  HOME = 'Home',
  BUILDINGS = 'Buildings',
  USERS = 'Users',
  REPORTS = 'Reports',
}

// DASHBOARD = 'Dashboard',
